import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Button,
} from '@sketchpixy/rubix';
import Dropzone from '../routes/Dropzone';

class UploadModal extends Component {
  constructor(props) {
    super(props);
  }

  hide = () => {
    this.props.uploadFilesCallback();
  };

  render() {
    return (
        <Modal show={this.props.showModal}>
          <Modal.Body>
            <Dropzone
                serviceTypeName={this.props.serviceTypeName}
                assetVersionId={this.props.assetVersionId}
                username={this.props.username}
                serviceName={this.props.serviceName}
                currentPath={this.props.currentPath}
                folders={this.props.folders}
                assetVersion={this.props.assetVersion} />
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.hide}>Close</Button>
          </Modal.Footer>
        </Modal>
    );
  }
}

UploadModal.propTypes = {
  showModal: PropTypes.bool,
};

export default UploadModal;


// WEBPACK FOOTER //
// ./src/component/UploadModal.js